import { RackStateItem } from './rack-state-item/rack-state-item';
import { Head, Line } from './rack-state-line.styled';
import { titles } from '../rack-state.consts';

export const RackStateLine = (props) => {
  const { obj, gate } = props;

  const getTitle = (name) => {
    return titles[name] ? titles[name].title : name;
  };

  const getInfo = (name) => {
    return titles[name] ? titles[name].info : name;
  };

  /**
   * get actual items
   */
  const getActual = () => {
    const items = [];
    Object.keys(titles).forEach((el) => {
      if (obj[el] !== undefined && obj[el] !== null) {
        items.push({ title: getTitle(el), info: getInfo(el), active: obj[el], name: el });
      }
    });
    return items;
  };

  const getItemsEl = () => {
    const items = getActual();
    const out = [];
    let outed = false;
    const els = items.map((el, idx) => {
      const { title, info, active } = el;

      let cl = '';
      if (el.name.indexOf('relay_sema_') !== -1) {
        if (!outed) {
          outed = true;
          cl = 'outed';
        }
      }
      return <RackStateItem className={cl} key={idx} title={title} info={info} active={active} />;
    });

    if (els.length) {
      if (gate) {
        out.push(<Head key="gate">Шлюз</Head>);
      }
      out.push(<Line key="line">{els}</Line>);
    }

    return out;
  };

  const itemsEl = getItemsEl();

  return <Line>{itemsEl}</Line>;
};
